export default __webpack_public_path__ + "static/media/ic_shopping.0c96382f.svg";